import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {
  PayrollManagementAccessService,
  PayrollManagementDestination
} from '../services/payroll-management-access.service';

@Injectable({ providedIn: 'root' })
export class PayrollApprovalGuard {
  constructor(
    private router: Router,
    private access: PayrollManagementAccessService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      this.router.navigate(['/login'], { queryParams: state.url ? { returnUrl: state.url } : {} });
      return false;
    }

    const user = JSON.parse(currentUser);
    const permissions = user?.permissionIDs || [];
    const destination = route.data.payrollManagementDestination as PayrollManagementDestination;
    if (this.access.canAccess(destination, permissions)) {
      return true;
    }

    this.router.navigateByUrl(this.access.defaultRoute(permissions));
    return false;
  }
}
